import { b as z, j as o, I as S } from "./Spinner-dTAYYnIx.js";
import { C as V, i as E, a as L, b as q, u as T, c as F } from "./useCarouselContext-LshUqZeh.js";
import b from "react";
import { u as P } from "./useResizeObserver-ghdBe7Hs.js";
import { a as R } from "./LoadMore-5nxHZX2o.js";
import { styled as p, css as d } from "styled-components";
import { g as v } from "./getBreakpoint-g8ShFv__.js";
import { s as I, d as y, a as m, B as f, r as W, T as U } from "./style-8UHgYe1v.js";
import { c as O } from "./Container.utils-sTvKNvoR.js";
import { e as l, s as C, f as N, m as A } from "./index-QRkynDgW.js";
import { T as H } from "./typography.styled-aDVGHct9.js";
import { A as j } from "./icon-arrow-8NL91Y9P.js";
import { C as k } from "./icon-chevron-KKUvu9gg.js";
const X = ".buttonBack___1mlaL,.buttonFirst___2rhFr,.buttonLast___2yuh0,.buttonNext___2mOCa,.buttonNext___3Lm3s,.dot___3c3SI{cursor:pointer}.image___xtQGH{display:block;width:100%;height:100%}.spinner___27VUp{position:absolute;top:calc(50% - 15px);left:calc(50% - 15px);width:30px;height:30px;animation-name:spin___S3UuE;animation-duration:1s;animation-timing-function:linear;animation-iteration-count:infinite;border:4px solid #a9a9a9;border-top-color:#000;border-radius:30px}@keyframes spin___S3UuE{0%{transform:rotate(0)}to{transform:rotate(1turn)}}.container___2O72F{position:relative;overflow:hidden;height:100%;width:100%}.overlay___IV4qY{position:absolute;top:0;left:0;bottom:0;right:0;opacity:0;cursor:zoom-in;transition:opacity .3s,transform .3s}.hover___MYy31,.loading___1pvNI,.zoom___3kqYk{opacity:1}.imageLoadingSpinnerContainer___3UIPD{position:absolute;top:0;right:0;bottom:0;left:0;background-color:#f4f4f4}.slide___3-Nqo{position:relative;display:block;box-sizing:border-box;height:0;margin:0;list-style-type:none}.slide___3-Nqo:focus{outline:none!important}.slideHorizontal___1NzNV{float:left}[dir=rtl] .slideHorizontal___1NzNV{direction:rtl;transform:scaleX(-1)}.slideInner___2mfX9{position:absolute;top:0;left:0;width:100%;height:100%}.focusRing___1airF{position:absolute;top:5px;right:5px;bottom:5px;left:5px;pointer-events:none;outline-width:5px;outline-style:solid;outline-color:Highlight}@media (-webkit-min-device-pixel-ratio:0){.focusRing___1airF{outline-style:auto;outline-color:-webkit-focus-ring-color}}.horizontalSlider___281Ls{position:relative;overflow:hidden;touch-action:pan-y pinch-zoom}[dir=rtl] .horizontalSlider___281Ls{direction:ltr;transform:scaleX(-1)}.horizontalSliderTray___1L-0W{overflow:hidden;width:100%}.verticalSlider___34ZFD{position:relative;overflow:hidden}.verticalSliderTray___267D8{overflow:hidden}.verticalTray___12Key{float:left}.verticalSlideTrayWrap___2nO7o{overflow:hidden}.sliderTray___-vHFQ{display:block;list-style:none;padding:0;margin:0}.sliderAnimation___300FY{transition:transform .5s;transition-timing-function:cubic-bezier(.645,.045,.355,1);will-change:transform}.masterSpinnerContainer___1Z6hB{position:absolute;top:0;right:0;bottom:0;left:0;background-color:#f4f4f4}", Y = p(V)`
  ${X};
`, M = p(E)`
  margin-block: -${l.spacer2};
  ${I("100%")}

  && {
    overflow: ${({ overflow: e }) => e};
  }

  > div {
    height: 100%;
  }

  .carousel {
    &__slider-tray {
      padding-block: ${l.spacer2};
      height: 100%;
    }

    &__slide-focus-ring {
      inset: -2px;
      outline-offset: ${l.spacer1};
      outline-width: 1px;
      outline-style: solid;
      ${y("outline-color", "dominant")};
    }

    &__slide {
      ${({ $gap: e }) => {
  if (!e)
    return;
  if (typeof e == "number")
    return d`
            ${m(
      f.xs,
      d`
                margin-inline: calc(${l[e]} / 2);
              `
    )}
            ${m(
      f.sm,
      d`
                margin-inline: 0 calc(${l[e]});
              `
    )}
          `;
  const i = v(e);
  return d`
          ${m(
    f.xs,
    d`
              margin-inline: calc(${C[i ?? "spacer0"]}px / 2);
            `
  )}
          ${m(
    f.sm,
    d`
              margin-inline: 0 calc(${C[i ?? "spacer0"]}px);
            `
  )}
        `;
}}
    }
  }

  :focus {
    outline: 2px solid;
    ${y("outline-color", "dominant")}
  }
`, B = d`
  border-radius: 100%;
  padding: ${W(l.spacer2)} !important;
`, D = p(L)`
  ${z}
  ${B}
`, Q = p(q)`
  ${z}
  ${B}
`, Z = p.div.attrs({
  $alignItems: "center",
  $justifyContent: "space-between"
})`
  ${N}
  ${I("100%")}
`, G = p(H).attrs({
  $textAlign: "center",
  $px: { xs: "spacer3" },
  as: "div",
  $variant: U.body
})`
  ${y("color", "dominant")}

  min-width: ${l.spacer10};
`, K = p.div.attrs({ $alignItems: "center", $justifyContent: "center" })`
  ${N}
  ${A}

  padding-inline: ${l.spacer1};

  ${({ $variant: e }) => e === "progress" && d`
      width: 100%;

      ${m(
  f.sm,
  d`
          width: calc(100% + ${l.spacer5});
          margin-inline: -${l.spacer3};
        `
)}
    `}
`, J = p.div`
  flex: 1 1 100%;
  padding: 0 ${l.spacer3};
`, ee = p.div.attrs({ $fluid: !0 })`
  padding-block: ${l.spacer2};
  overflow: hidden;
  ${m(f.sm, O)}
`;
var w = /* @__PURE__ */ ((e) => (e.PREVIOUS = "previous", e.NEXT = "next", e))(w || {});
const ie = ({ containerWidth: e, tileWidth: i, gap: a, visibleSlides: t }) => {
  if (t)
    return t;
  if (i && e) {
    const s = i + (a ? C[a] : 0);
    return e / s;
  } else
    return 1;
}, te = ({
  children: e,
  naturalSlideHeight: i = 100,
  naturalSlideWidth: a = 125,
  totalSlides: t,
  isIntrinsicHeight: s = !0,
  ...u
}) => /* @__PURE__ */ o.jsx(
  Y,
  {
    ...u,
    isIntrinsicHeight: s,
    naturalSlideHeight: i,
    naturalSlideWidth: a,
    totalSlides: t,
    children: e
  }
), oe = ({ children: e, index: i, ...a }) => {
  const { visibleSlides: t, currentSlide: s, totalSlides: u } = T(), r = i >= s && i < s + t, c = r ? e : b.Children.map(e, (n) => b.isValidElement(n) ? b.cloneElement(n, {
    tabIndex: -1
  }) : n);
  return /* @__PURE__ */ o.jsx(
    F,
    {
      index: i,
      ...a,
      role: "group",
      "aria-label": `carousel item ${i + 1} of ${u}`,
      "aria-selected": void 0,
      "aria-hidden": !r,
      children: c
    }
  );
}, re = ({ children: e, gap: i, overflow: a = "hidden" }) => /* @__PURE__ */ o.jsx(Z, { "data-qa": "carousel", children: /* @__PURE__ */ o.jsx(M, { overflow: a, $gap: i, role: "region", "aria-label": "carousel", children: b.Children.map(e, (t, s) => /* @__PURE__ */ o.jsx(oe, { index: s, children: t })) }) }), ne = ({
  previousButtonAriaLabel: e,
  nextButtonAriaLabel: i,
  slideDividerLabel: a,
  $variant: t = "default",
  onChange: s,
  ...u
}) => {
  const { currentSlide: r, visibleSlides: c, totalSlides: n, infinite: h } = T(), g = (_, $) => {
    s && s(_, $);
  }, x = r + c >= n ? n : r + c;
  return /* @__PURE__ */ o.jsxs(K, { ...u, $variant: t, children: [
    /* @__PURE__ */ o.jsx(
      Q,
      {
        "aria-disabled": r === 0,
        "aria-label": e,
        disabled: r === 0,
        $state: r === 0 ? "disabled" : "active",
        $variant: "icon",
        onClick: (_) => g(_, w.PREVIOUS),
        $mx: { lg: t === "default" ? "spacer3" : "spacer0" },
        children: /* @__PURE__ */ o.jsx(S, { icon: t === "default" ? j : k, size: "sm" })
      }
    ),
    t === "progress" ? /* @__PURE__ */ o.jsx(J, { children: !!n && /* @__PURE__ */ o.jsx(R, { value: x, max: n, "data-qa": "loadmore-progress" }) }) : /* @__PURE__ */ o.jsxs(G, { "data-qa": "quick-view-image-count", children: [
      Math.ceil(r + Math.floor(c)),
      " ",
      a,
      " ",
      n
    ] }),
    /* @__PURE__ */ o.jsx(
      D,
      {
        "aria-disabled": !h && r + c === n ? "true" : "false",
        "aria-label": i,
        disabled: !h && r + c === n,
        $state: !h && r + c === n ? "disabled" : "active",
        $variant: "icon",
        onClick: (_) => g(_, w.NEXT),
        $mx: { lg: t === "default" ? "spacer3" : "spacer0" },
        children: /* @__PURE__ */ o.jsx(S, { icon: t === "default" ? j : k, rotation: 180, size: "sm" })
      }
    )
  ] });
}, xe = ({
  children: e,
  t: i,
  tileWidth: a,
  visibleSlides: t,
  gap: s,
  $variant: u = "progress",
  overflow: r,
  ...c
}) => {
  const [{ width: n }, h] = P("content-box"), g = v(a), x = v(s), _ = ie({
    tileWidth: g,
    gap: x,
    visibleSlides: t,
    containerWidth: n
  }), $ = b.Children.count(e);
  return /* @__PURE__ */ o.jsx(ee, { ref: h, children: /* @__PURE__ */ o.jsxs(te, { ...c, totalSlides: $, visibleSlides: _, children: [
    /* @__PURE__ */ o.jsx(re, { gap: x, overflow: r, children: e }),
    $ > _ && /* @__PURE__ */ o.jsx(ne, { ...i, $mt: "spacer5", $variant: u })
  ] }) });
};
export {
  xe as C,
  ne as a,
  te as b,
  re as c
};
